import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { IBrushType, PenEventName, PLAYSTATE } from "../../common/enums";
import { MappingStorage } from "../../common/mapper";
import { getNPaperSize_pu, isPlatePaper } from "../../common/noteserver/SurfaceInfo";
import { InkStorage, InkStorageEventName } from "../../common/penstorage";
import { StrokeStatus } from "../../common/structures";
import { deepClone, hasNullPageInfo, hasSamePage, hasSameRect, isSameArray, isSamePage, isSamePageRect, makeNPageIdStr, uuidv4 } from "../../common/util";
import PenManager from "../../neosmartpen/PenManager";
import HoverCursor from "./HoverCursor";
import PenBasedRenderWorker from "./worker/PenBasedRenderWorker";
// import interact from 'interactjs'
const timeTickDuration = 20; // ms
const inkContainerDiv = {
    position: "absolute",
    zoom: 1,
    left: 0,
    top: 0,
    // zIndex: zIndex_inkContainerDiv,
    // 1117
    overflow: "hidden",
};
const inkCanvas = {
    position: "absolute",
    zoom: 1,
    left: 0,
    top: 0
    // zIndex: zIndex_inkContainerDiv
};
const inkContainerDivCompleted = Object.assign({}, inkContainerDiv);
const inkCanvasCompleted = Object.assign({}, inkCanvas);
const pdfContainerDiv = Object.assign({}, inkContainerDiv);
const pdfCanvas = Object.assign({}, inkCanvas);
/**
 * TO DO: 2020/11/05
 *    1)  Pen에서 Event를 받아 실시간 rendering만 하는 component로 만들것
 *
 */
export default class PenBasedRenderer extends React.Component {
    get renderer() {
        if (!this._renderer) {
            // if (this.viewSize.width > 0 && this.viewSize.height > 0) {
            this._renderer = this.initRenderer(this.viewSize, this.pdfSize, this.props.id);
            // 렌더러를 먼저 가져오게 되면 rederbase의 h가 이상하게 세팅되니 조심해야 하는데,
            //  -_-; 2021/05/05
            const transform = MappingStorage.getInstance().getNPageTransform(this.props.pageInfo);
            const r = this._renderer;
            r.setTransformParameters(transform.h);
            // }
        }
        return this._renderer;
    }
    constructor(props) {
        super(props);
        this.state = {
            sizeUpdate: 0,
            penEventCount: 0,
            strokeCount: 0,
            liveDotCount: 0,
            playState: PLAYSTATE.live,
            renderCount: 0,
            cropRect: null,
            hoverCursor: { x: 0, y: 0, show: false, time: undefined, color: "rgba(0,0,0,0)", numFollowings: 5 },
            updateCounter: 0,
        };
        this.forceToReloadPage = true;
        this.pdfSize = { scale: 1, width: 1, height: 1 };
        this.viewSize = { width: 0, height: 0 };
        this.canvasCssSize = { width: 0, height: 0 };
        // mainDiv: HTMLDivElement = null;
        this.canvasId = "";
        this.canvas = null;
        this.backCanvasId = "";
        this.backCanvas = null;
        this.pdfCanvasId = "";
        this.pdfCanvas = null;
        this.shouldSendPageInfo = false;
        this.subscribedPens = [];
        // 2021/08/19
        this._divId = `renderer-${uuidv4()}`;
        //#region Stroke event setting - 펜과 InkStorage에서 나오는 이벤트 수신과 해제
        /**
         * storage로 부터 들어오는, 추가되는 스트로크 이벤트를 받는 것으로 설정
         * @private
         * @memberof PenBasedRenderer
         */
        this.subScriptStorageEvent = () => {
            const is = this._inkstorage;
            // console.log(`Renderer(${this.props.parentName}): subScriptStorageEvent`);
            const filter = { mac: null };
            is.addEventListener(PenEventName.ON_PEN_DOWN, this.onLivePenDown_byStorage, filter);
            is.addEventListener(PenEventName.ON_PEN_PAGEINFO, this.onLivePenPageInfo_byStorage, filter);
            is.addEventListener(PenEventName.ON_PEN_MOVE, this.onLivePenMove_byStorage, filter);
            is.addEventListener(PenEventName.ON_PEN_UP, this.onLivePenUp_byStorage, filter);
        };
        /**
         * storage의 이벤트 수신을 해제
         * @private
         * @memberof PenBasedRenderer
         */
        this.unsubScriptStorageEvent = () => {
            const is = this._inkstorage;
            is.removeEventListener(PenEventName.ON_PEN_DOWN, this.onLivePenDown_byStorage);
            is.removeEventListener(PenEventName.ON_PEN_PAGEINFO, this.onLivePenPageInfo_byStorage);
            is.removeEventListener(PenEventName.ON_PEN_MOVE, this.onLivePenMove_byStorage);
            is.removeEventListener(PenEventName.ON_PEN_UP, this.onLivePenUp_byStorage);
        };
        /**
         * property의 펜이 추가되면 펜의 이벤트를 수신
         * @private
         * @param {INeoSmartpen} pen
         * @memberof PenBasedRenderer
         */
        this.subscribePenEvent = (pen) => {
            if (!this.subscribedPens.includes(pen)) {
                this.subscribedPens.push(pen);
                pen.addEventListener(PenEventName.ON_PEN_DOWN, this.onLivePenDown);
                pen.addEventListener(PenEventName.ON_PEN_PAGEINFO, this.onLivePenPageInfo);
                pen.addEventListener(PenEventName.ON_PEN_MOVE, this.onLivePenMove);
                pen.addEventListener(PenEventName.ON_PEN_UP, this.onLivePenUp);
                pen.addEventListener(PenEventName.ON_HOVER_MOVE, this.onLiveHoverMove);
                // pen.addEventListener(PenEventName.ON_PEN_HOVER_PAGEINFO, this.onLiveHoverPageInfo);
                // virual pen down/up은, 펜 스트로크가 이어지고 있음에도 페이지가 바뀌는 경우에 발생한다
                pen.addEventListener(PenEventName.ON_PEN_DOWN_VIRTUAL, this.onLivePenDown);
                pen.addEventListener(PenEventName.ON_PEN_UP_VIRTUAL, this.onLivePenUp);
                // InkStorage의 InkStorageEventName.ON_NETWORK_STROKE_ADDED로 옮겼으니, 검토 후 삭제할 것 ==> 삭제했음
                // pen.addEventListener(PenEventName.ON_STROKE_RECEIVED, this.onStrokeReceived);
                // 2021/07/02, 플레이트 입력을 받기 위해 넣어 놓은 것
                if (this.props.isMainView || this.props.isPriorityView) {
                    const rndr = this.renderer;
                    pen.setPageSizeRetreiveFn(rndr.getViewSize, this.props.enablePlateInput);
                }
                // this.renderer.createHoverCursor(pen);
            }
        };
        /**
         * property에서 펜이 삭제되면 펜 이벤트 수신을 해제
         * @private
         * @param {INeoSmartpen} pen
         * @memberof PenBasedRenderer
         */
        this.unsubscribePenEvent = (pen) => {
            while (this.subscribedPens.includes(pen)) {
                pen.removeEventListener(PenEventName.ON_PEN_DOWN, this.onLivePenDown);
                pen.removeEventListener(PenEventName.ON_PEN_PAGEINFO, this.onLivePenPageInfo);
                pen.removeEventListener(PenEventName.ON_PEN_MOVE, this.onLivePenMove);
                pen.removeEventListener(PenEventName.ON_PEN_UP, this.onLivePenUp);
                pen.removeEventListener(PenEventName.ON_HOVER_MOVE, this.onLiveHoverMove);
                pen.removeEventListener(PenEventName.ON_PEN_DOWN_VIRTUAL, this.onLivePenDown);
                pen.removeEventListener(PenEventName.ON_PEN_UP_VIRTUAL, this.onLivePenUp);
                // InkStorage의 InkStorageEventName.ON_NETWORK_STROKE_ADDED로 옮겼으니, 검토 후 삭제할 것 ==> 삭제했음, 2021/07/06
                // pen.removeEventListener(PenEventName.ON_STROKE_RECEIVED, this.onStrokeReceived);
                // 2021/07/02, 플레이트 입력을 받기 위해 넣어 놓은 것
                const rndr = this.renderer;
                pen.removetPageSizeRetreiveFn();
                const index = this.subscribedPens.indexOf(pen);
                this.subscribedPens.splice(index, 1);
                // this.renderer.removeHoverCursor(pen);
            }
        };
        /**
         * 모든 펜의 이벤트 수신을 해제
         * @private
         * @memberof PenRendererBaseComponent
         */
        this.unsubscribeAllPensEvent = () => {
            // this.subscribedPens.forEach(pen => {
            //   this.unsubscribePenEvent(pen);
            // });
            const pm = PenManager.getInstance();
            const pens = pm.getPens();
            pens.forEach(pen => {
                this.unsubscribePenEvent(pen);
            });
        };
        /**
         * 2021/07/06
         *
         * @private
         * @memberof PenBasedRenderer
         */
        this.unsubscribeStaticInkStorageEvent = () => {
            this._inkstorage.removeEventListener(InkStorageEventName.ON_STROKE_ERASED, this.renderer.onStrokeErased);
            // 2021/07/06
            this._inkstorage.removeEventListener(InkStorageEventName.ON_NETWORK_STROKE_ADDED, this.onStrokeReceived);
            // 2022/11/23
            this._inkstorage.removeEventListener(InkStorageEventName.ON_STROKE_ADDED, this.onStrokeReceived);
            // 2022/08/16 - june
            this._inkstorage.removeEventListener(InkStorageEventName.ON_INKSTORE_STROKE_LOADED, this.onInkStoreStrokeLoaded);
        };
        this.subscribeStaticInkStorageEvent = () => {
            this._inkstorage.addEventListener(InkStorageEventName.ON_STROKE_ERASED, this.renderer.onStrokeErased, null);
            // 2021/07/06
            this._inkstorage.addEventListener(InkStorageEventName.ON_NETWORK_STROKE_ADDED, this.onStrokeReceived, null);
            // 2022/11/23
            this._inkstorage.addEventListener(InkStorageEventName.ON_STROKE_ADDED, this.onStrokeReceived, null);
            //2022/08/16 - june
            this._inkstorage.addEventListener(InkStorageEventName.ON_INKSTORE_STROKE_LOADED, this.onInkStoreStrokeLoaded, null);
        };
        /**
         * pen array를 제외하고는 event listening을 하지 않도록
         * @private
         * @param {INeoSmartpen[]} pens
         * @memberof PenRendererBaseComponent
         */
        this.makeUpPenEvents = (pens) => {
            // 먼저 이벤트 리스닝을 해제할 것은 하고
            const needToUnsubscribe = this.subscribedPens.filter(pen => !pens.includes(pen));
            needToUnsubscribe.forEach(pen => {
                this.unsubscribePenEvent(pen);
            });
            const needToSubscribe = pens.filter(pen => !this.subscribedPens.includes(pen));
            needToSubscribe.forEach(pen => {
                this.subscribePenEvent(pen);
            });
        };
        //#endregion
        /**
         * 렌더러 워커가 페이지를 변환할 때 쓸, 해당 페이지에 이미 있던 스트로크를 가져오는 부분
         *
         * @param {IPageSOBP} pageInfo
         * @memberof PenBasedRenderer
         */
        this.getPageStrokesFromStorage = (pageInfo, pens, surfaceOwnerIds, writerIds) => {
            const bid = IBrushType.ERASER;
            const sStatus = StrokeStatus.ERASED;
            if (this.props.playState === PLAYSTATE.live) {
                // 잉크 스토리지에서 가져온다
                const strokesAll = this._inkstorage.getPageStrokes(pageInfo);
                const filteredStrokes = strokesAll.filter(stroke => 
                // const penIncludes = !!pens.find(pen => (pen.mac === stroke.mac) && (pen.inputType.local === stroke.inputType.local));
                // const ownerIncludes = (!surfaceOwnerIds) || surfaceOwnerIds.includes(stroke.surfaceOwnerId);
                // const writerIncludes = (!writerIds) || writerIds.includes(stroke.writerId);
                ((stroke.brushType !== bid) &&
                    (stroke.status !== sStatus) &&
                    // TODO: filtered pen property를 추가할 것
                    // (!!pens.find(pen => (pen.mac === stroke.mac) && (pen.inputType.local === stroke.inputType.local))) &&
                    ((!surfaceOwnerIds) || surfaceOwnerIds.includes(stroke.surfaceOwnerId)) &&
                    ((!writerIds) || writerIds.includes(stroke.writerId))));
                return filteredStrokes;
            }
            if (this.props.replayStorage) {
                let strokes = [];
                strokes.push(...this.props.replayStorage.getPageStrokes(pageInfo));
                strokes.push(...this._inkstorage.getPageStrokes(pageInfo));
                strokes = strokes.sort((a, b) => a.startTime - b.startTime);
                const filteredStrokes = strokes.filter(stroke => stroke.status !== StrokeStatus.ERASED);
                return filteredStrokes;
            }
            return [];
        };
        this.onCanvasPositionChanged = (arg) => {
            this.viewPos = arg;
            // console.log(arg.offsetX, arg.offsetY)
            if (this.props.onCanvasPositionChanged)
                this.props.onCanvasPositionChanged(arg);
        };
        // 2022/11/18
        this.onCanvasSizeChaned = (arg) => {
            if (!this._mounted)
                return;
            const { width, height } = arg;
            if (width && height) {
                this.canvasCssSize = arg;
                this.setState({ updateCounter: this.state.updateCounter + 1 });
            }
        };
        this._mounted = false;
        this.initRenderer = (viewSize, pageSize, id) => {
            /** @type {{width:number, height:number}} */
            // console.log(`VIEW SIZE${callstackDepth()} initRenderer:   view(${viewSize.width}, ${viewSize.height})  page(${pageSize.width}, ${pageSize.height})`);
            const options = {
                divId: this._divId,
                id: id,
                canvasId: this.canvasId,
                canvas: this.canvas,
                canvasCompletedId: this.backCanvasId,
                canvasCompleted: this.backCanvas,
                canvasPdfId: this.pdfCanvasId,
                canvasPdf: this.pdfCanvas,
                viewSize,
                pageSize_pu: pageSize,
                viewFit: this.props.fitType,
                pens: this.props.pens,
                fitMargin: this.props.padding,
                onCanvasPositionChanged: this.onCanvasPositionChanged,
                rotation: this.props.rotation,
                disablePanZoom: this.props.disablePanZoom,
                disableAutoFocus: this.props.disableAutoFocus,
                showGrid: this.props.showGrid,
                disableVirtualPen: this.props.disableMousePen,
                onViewPositionControlledBy: this.props.onViewPositionControlledBy,
                setViewFitFn: this.props.setViewFitFn,
                onMouseDown: this.props.onMouseDown,
                onMouseMove: this.props.onMouseMove,
                onMouseUp: this.props.onMouseUp,
                onMouseWheel: this.props.onMouseWheel,
                onTouchPress: this.props.onTouchPress,
                onTouchTap: this.props.onTouchTap,
                isCropMode: this.props.isCropMode,
                onCropRangeChagned: this.props.onCropRangeChagned,
                laserPointer: this.props.laserPointer,
                onPageChanged: this.onWorkerPageChanged,
                pdf: this.props.pdf,
                pdfPageNo: this.props.pdfPageNo,
                disableAnyMouseAction: this.props.disableAnyMouseAction,
                enablePlateInput: this.props.enablePlateInput,
                reportCursorMoveFn: this.onHoverCursorReported,
                storage: this._inkstorage,
                opacityConverter: this.props.opacityConverter,
                isPriorityView: this.props.isPriorityView || this.props.isMainView,
                onSizeChanged: this.onCanvasSizeChaned,
            };
            const renderer = new PenBasedRenderWorker(options);
            return renderer;
        };
        // 2021/08/04
        this.onScaleChanged = (scale) => {
            console.log(`penRenderer, onScaleChaned: ${scale}`);
            this.renderer.zoomToPoint({ x: 100, y: 100 }, scale);
            // this._internal.viewPos = { ...this._internal.viewPos, zoom: scale };
        };
        this.onWorkerPageChanged = (pageInfo) => {
            console.log(`Renderer: onWorkerPageChagned ${makeNPageIdStr(pageInfo)}`);
            //   const msi = MappingStorage.getInstance();
            //   const mapPdfPage = msi.getAssociatedPdfPage(pageInfo);
            // rndr.changePdfPage(this.props.pdf, np.pdfPageNo);
        };
        this.onViewResized = ({ width, height }) => {
            this.renderer.onViewSizeChanged({ width, height });
            console.log(`Renderer: onViewResized = ${width} ${height}`);
        };
        this.shouldNeedToDraw = (pageInfo) => {
            if (!isSamePage(this.props.pageInfo, pageInfo)) {
                return false;
            }
            return true;
        };
        this.isVisibleOwnerAndWriter = (stroke) => {
            // return testOwnerAndWriter(stroke, this.props.surfaceOwnerIds, this.props.writerIds);
            const owners = this.props.surfaceOwnerIds;
            const writers = this.props.writerIds;
            // 이건 참 헷갈리는 문제네.... filter를 filter 답게 쓰려면 아래와 같이
            const ownerValid = (!owners) || owners.includes(stroke.surfaceOwnerId);
            const writerValid = (!writers) || writers.includes(stroke.writerId);
            // 이전 버전과 호환성을 위해서는 아래와 같이
            // const ownerValid = (!owners) || (!stroke.surfaceOwnerId) || owners.includes(stroke.surfaceOwnerId);
            // const writerValid = (!writers) || (!stroke.writerId) || writers.includes(stroke.writerId);
            return ownerValid && writerValid;
        };
        /**
         *
         *
         * @param {IPenToViewerEvent} event
         */
        this.onLivePenDown = (event) => {
            if (!this.isVisibleOwnerAndWriter(event.stroke))
                return;
            this.renderer.createLiveStroke(event);
        };
        this.onLivePenDown_byStorage = (event) => {
            // console.log(`Renderer(${makeNPageIdStr(this.props.pageInfo)}): onLivePenDown from InkStorage`);
        };
        /**
         *
         *
         * @param {IPenToViewerEvent} event
         * @memberof PenBasedRenderer
         */
        this.onLivePenPageInfo = (event) => {
            if (!this.isVisibleOwnerAndWriter(event.stroke))
                return;
            const { section, owner, book, page } = event;
            const prevPageInfo = this.props.pageInfo;
            if (isSamePage(prevPageInfo, event) && (!this.shouldSendPageInfo)) {
                return;
            }
            this.shouldSendPageInfo = false;
            /** pdf pageNo를 바꿀 수 있게, container에게 전달한다. */
            if (this.props.onNcodePageChanged) {
                this.props.onNcodePageChanged({ section, owner, book, page }, event.stroke);
            }
        };
        this.onLivePenPageInfo_byStorage = (event) => {
            // const { section, owner, book, page } = event;
            // const pageInfo = { section, owner, book, page } as IPageSOBP;
            // console.log(`Renderer(${makeNPageIdStr(this.props.pageInfo)}): PageInfo from InkStorage, pageInfo=${makeNPageIdStr(pageInfo)}`);
            // this.onLivePenPageInfo(event);
        };
        /**
         *
         *
         * @param {IPenToViewerEvent} event
         * @memberof PenBasedRenderer
         */
        this.onLivePenMove = (event) => {
            if (!this.isVisibleOwnerAndWriter(event.stroke))
                return;
            if (this.renderer && this.shouldNeedToDraw(event.stroke)) {
                this.renderer.pushLiveDot(event);
                if (this.props.laserPointer) {
                    this.renderer.movePenTracker(event); // kitty, 2021/04/08
                }
            }
        };
        this.onLivePenMove_byStorage = (event) => {
            if (!this.isVisibleOwnerAndWriter(event.stroke))
                return;
            //   this.renderer.pushLiveDot_byStorage(event);
        };
        /**
         *
         * @param {{strokeKey:string, mac:string, stroke, section:number, owner:number, book:number, page:number}} event
         */
        this.onLivePenUp = (event) => {
            if (!this.isVisibleOwnerAndWriter(event.stroke))
                return;
            this.renderer.closeLiveStroke(event);
        };
        this.onLivePenUp_byStorage = (event) => {
            if (!this.isVisibleOwnerAndWriter(event.stroke))
                return;
            const { section, owner, book, page } = event;
            const pageInfo = { section, owner, book, page };
            if (this.renderer && isSamePage(this.props.pageInfo, pageInfo)) {
                this.renderer.closeLiveStroke_byStorage(event);
            }
        };
        /**
         *
         * @param {{strokeKey:string, mac:string, stroke, section:number, owner:number, book:number, page:number}} event
         */
        this.onStrokeReceived = (event) => {
            const stroke = event.stroke;
            if (stroke.brushType === IBrushType.ERASER) {
                this.renderer.handleEraserStroke(stroke);
                return;
            }
            if (!this.isVisibleOwnerAndWriter(event.stroke))
                return;
            // TODO: 현재 페이지가 아닌 것에 대한 stroke가 들어올 때 페이지를 변환해 줘야 한다. 2021/07/06
            const sobp = stroke;
            const np = this.props;
            if (!isSamePage(sobp, np.pageInfo)) {
                if (this.props.onNcodePageChanged) {
                    this.props.onNcodePageChanged(sobp, stroke);
                }
                // this.changePagePrivate(sobp,
                //   np.pens, np.surfaceOwnerIds, np.writerIds, np.pdf, np.pdfPageNo);
            }
            // 스트로크를 넣는다.
            this.renderer.handleStrokeReceived(event);
        };
        this.onInkStoreStrokeLoaded = (event) => {
            const p = this.props;
            console.log("onInkStoreStrokeLoaded pageInfo : ", p.pageInfo);
            this.changePagePrivate(p.pageInfo, p.pens, p.surfaceOwnerIds, p.writerIds, p.pdf, p.pdfPageNo, true);
        };
        /**
         * 2021/07/06
         *
         * @private
         * @param {IPageSOBP} pageInfo
         * @param {INeoSmartpen[]} pens
         * @param {string[]} surfaceOwnerIds
         * @param {string[]} writerIds
         * @param {NeoPdfDocument} pdf
         * @param {number} pdfPageNo
         * @memberof PenBasedRenderer
         */
        this.changePagePrivate = (pageInfo, pens, surfaceOwnerIds, writerIds, pdf, pdfPageNo, forceRenderStroke) => {
            const rndr = this.renderer;
            const msi = MappingStorage.getInstance();
            const strokes = this.getPageStrokesFromStorage(pageInfo, pens, surfaceOwnerIds, writerIds);
            const transform = msi.getNPageTransform(pageInfo);
            const pageDesc = msi.getAssociatedPdfPage(pageInfo);
            let size_pu;
            if (pageDesc) {
                size_pu = pageDesc.pageMapping.pdfDesc.size_pu;
            }
            else {
                // 해당하는 PDF가 없으면 사이즈를 알수가 없으니, NPaper라고 생각한다.
                size_pu = getNPaperSize_pu(pageInfo);
            }
            rndr.changePage_20210418(pageInfo, strokes, size_pu, transform.h, pdf, pdfPageNo, forceRenderStroke);
            // // console.log(`pageChange: PenBasedRenderer: rendering worker changing pdf page  ${np.pdfPageNo}`);
        };
        this.removeAllCanvasObjectOnActivePage = (pageInfo) => {
            if (this.renderer && isSamePage(this.props.pageInfo, pageInfo)) {
                this.renderer.removeAllCanvasObject();
            }
        };
        // onLiveHoverPageInfo = (event: IPenToViewerEvent) => {
        // }
        /**
         *
         *
         * @param {IPenToViewerEvent} event
         * @memberof PenBasedRenderer
         */
        this.onLiveHoverMove = (event) => {
            const same = this.shouldNeedToDraw(event.event);
            // console.log( `${makeNPageIdStr(event.event as IPageSOBP)} <<  ${makeNPageIdStr(this.props.pageInfo as IPageSOBP)}`)
            if (this.props.laserPointer && same) {
                this.renderer.moveHoverPoint(event);
            }
        };
        // 2021/04/18
        this.reportReplayTime = (deltaTime) => {
            if (this.props.onReplayTimeChanged) {
                this.props.onReplayTimeChanged(deltaTime);
            }
        };
        this.reportReplayStateChanged = (playState) => {
            if (this.props.onReplayStateChanged) {
                this.props.onReplayStateChanged(playState);
            }
        };
        this.handleReplayStorageChanged = (rs) => {
            this._replay.replayStorage = rs;
            this.stopInterval();
            this._replay = {
                replayStorage: rs,
                deltaTime: 0,
                speed: this._replay.speed ? this._replay.speed : 1,
                timer: undefined,
                pageInfo: undefined,
                chunkPlaying: undefined,
            };
            this.forceToReloadPage = true;
            this.drawPageAtTime(0, true);
            this.reportReplayStateChanged(PLAYSTATE.pause);
            this.reportReplayTime(this._replay.deltaTime);
        };
        this.drawPageAtTime = (deltaTime, needToLoadPage = false) => {
            const setCurrReplayChunk = (deltaTime) => {
                const idx = this._replay.replayStorage.getChunkIndex(deltaTime);
                this._replay.chunkPlaying = idx;
            };
            if (this._replay.chunkPlaying === undefined || this._replay.chunkPlaying < 0) {
                setCurrReplayChunk(deltaTime);
                needToLoadPage = true;
            }
            const nextChunk = this._replay.replayStorage.pageChunks[this._replay.chunkPlaying + 1];
            if (nextChunk && deltaTime >= nextChunk.startDeltaTime) {
                this._replay.chunkPlaying++;
                needToLoadPage = true;
            }
            const currChunk = this._replay.replayStorage.pageChunks[this._replay.chunkPlaying];
            if (currChunk !== undefined && needToLoadPage) {
                /** pdf pageNo를 바꿀 수 있게, container에게 전달한다. */
                if (this.props.onNcodePageChanged) {
                    this.props.onNcodePageChanged(currChunk.pageInfo, null);
                }
            }
            this._renderer.setReplayAbsTime(deltaTime + this._replay.replayStorage.startTime);
            // this._renderer.drawPageAtTime(deltaTime);
        };
        this.onTick = () => {
            const timePassed = timeTickDuration * this._replay.speed;
            const deltaTime = this._replay.deltaTime + timePassed;
            this._replay.deltaTime = deltaTime;
            this.drawPageAtTime(deltaTime);
            if (deltaTime > this.props.replayStorage.duration) {
                this.reportReplayStateChanged(PLAYSTATE.pause);
            }
            this.reportReplayTime(deltaTime);
        };
        this.stopInterval = () => {
            if (this._replay.timer) {
                clearInterval(this._replay.timer);
                this._replay.timer = null;
            }
        };
        this.replayStart = () => {
            this.stopInterval();
            // 자동 멈춤 지점을 설정
            this._replay.timer = window.setInterval(this.onTick, timeTickDuration);
            this.reportReplayTime(this._replay.deltaTime);
            this.drawPageAtTime(this._replay.deltaTime);
        };
        this.replayPause = () => {
            this.stopInterval();
        };
        this.replayRewind = () => {
            this._replay.deltaTime = 0;
            this._replay.chunkPlaying = undefined;
            this.drawPageAtTime(0);
            this.reportReplayTime(0);
        };
        this.setPlayTime = (deltaTime) => {
            if (deltaTime && this._replay.replayStorage) {
                const idx = this._replay.replayStorage.getChunkIndex(deltaTime);
                let needToLoadPage = false;
                if (idx !== this._replay.chunkPlaying) {
                    needToLoadPage = true;
                    this._replay.chunkPlaying = idx;
                }
                this._replay.deltaTime = deltaTime;
                this.drawPageAtTime(deltaTime, needToLoadPage);
            }
        };
        this.onHoverCursorReported = (clientX, clientY, show, type) => {
            if (!this._mounted)
                return;
            setTimeout((now) => {
                const new_now = (new Date()).getTime();
                if (this.state.hoverCursor && new_now - this.state.hoverCursor.time > 1000) {
                    this.setState({ hoverCursor: undefined });
                }
            }, 1500);
            const now = (new Date()).getTime();
            if (this._mounted) {
                this.setState({
                    hoverCursor: {
                        x: clientX,
                        y: clientY,
                        show: show,
                        time: now,
                        color: type === "hover" ? "rgba(255,0,0,100)" : "rgba(0,0,255,100)",
                        numFollowings: type === "hover" ? 10 : 1,
                    }
                });
            }
        };
        this.disablePenCursor = () => {
            if (this._mounted) {
                this.setState({
                    hoverCursor: {
                        x: this.state.hoverCursor.x,
                        y: this.state.hoverCursor.y,
                        show: false,
                        time: 0,
                        color: "rgba(0,0,0,0)",
                        numFollowings: 0,
                    }
                });
            }
        };
        const { handleChildReport, playState, viewSize, pdfSize } = props;
        this.canvasId = "live-" + uuidv4();
        this.backCanvasId = "completed-" + uuidv4();
        this.pdfCanvasId = "pdf-" + uuidv4();
        this.state.playState = playState ? playState : PLAYSTATE.live;
        this.viewSize = Object.assign({}, viewSize);
        this.pdfSize = Object.assign(Object.assign({}, pdfSize), { scale: 1 });
        this.viewPos = { offsetX: 0, offsetY: 0, zoom: 1 };
        this._inkstorage = props.storage ? props.storage : InkStorage.getInstance();
        if (handleChildReport) {
            handleChildReport(this);
        }
        this._replay = {
            speed: 1,
            deltaTime: 0,
            timer: undefined,
            replayStorage: undefined,
            pageInfo: undefined,
            chunkPlaying: undefined,
        };
    }
    /**
     * @override
     * @public
     */
    componentDidMount() {
        this._mounted = true;
        const { pens, pdfSize } = this.props;
        // console.log(`PenBasedRenderer: size ${this.pdfSize.width}, ${this.pdfSize.height}`);
        // console.log("Renderer Inited");
        this.pdfSize = Object.assign({ scale: 1 }, pdfSize);
        // this.initRenderer(this.props.viewSize, this.pdfSize);
        this.makeUpPenEvents(pens);
        // 2021/07/06
        this.subscribeStaticInkStorageEvent();
        if (this.props.fromStorage) {
            // console.log(`Renderer(${this.props.parentName}): componentDidMount`);
            this.subScriptStorageEvent();
        }
        // this._inkstorage.addEventListener(PageEventName.PAGE_CLEAR, this.removeAllCanvasObjectOnActivePage, null);
        const repeatIds = window.setInterval(() => {
            const { width: w, height: h } = this.canvasCssSize;
            if (w && h) {
                window.clearInterval(repeatIds);
                this.setState({ updateCounter: this.state.updateCounter + 1 });
            }
            else {
                const size = this.renderer.getCanvasCssSize();
                if ((size === null || size === void 0 ? void 0 : size.width) && (size === null || size === void 0 ? void 0 : size.height)) {
                    const { width, height } = size;
                    this.canvasCssSize = { width, height };
                    window.clearInterval(repeatIds);
                    this.setState({ updateCounter: this.state.updateCounter + 1 });
                }
            }
        }, 100);
    }
    /**
     * @override
     * @public
     */
    shouldComponentUpdate(np, ns) {
        let ret = false;
        const p = this.props;
        const s = this.state;
        const rndr = this.renderer;
        const opt = this.renderer._opt;
        let forceRenderStroke = false;
        if (p.forceDeltaTime !== np.forceDeltaTime) {
            this.setPlayTime(np.forceDeltaTime);
        }
        // page filter가 바뀐 경우, pen, writer, surface owner
        if (!isSameArray(np.pens, p.pens) || !isSameArray(np.surfaceOwnerIds, p.surfaceOwnerIds) || !isSameArray(np.writerIds, p.writerIds)) {
            if (!isSameArray(np.pens, p.pens)) {
                this.makeUpPenEvents(np.pens);
            }
            // 1123
            // const strokes = this.getPageStrokesFromStorage(np.pageInfo, np.pens, np.surfaceOwnerIds, np.writerIds);
            // const transform = MappingStorage.getInstance().getNPageTransform(np.pageInfo);
            const pageDesc = MappingStorage.getInstance().getAssociatedPdfPage(np.pageInfo);
            if (pageDesc) {
                this.forceToReloadPage = true;
                ret = true;
                forceRenderStroke = true;
                // 1123
                // const size_pu = pageDesc.pageMapping.pdfDesc.size_pu;
                // rndr.changePage_20210418(
                //   np.pageInfo,
                //   strokes,
                //   size_pu,
                //   transform.h,
                //   np.pdf,
                //   np.pdfPageNo
                // );
            }
        }
        if (p.fitType !== np.fitType) {
            this.viewSize = Object.assign({}, np.viewSize);
            opt.viewFit = np.fitType;
            this.onViewResized(this.viewSize);
            console.log(`PenBasedRenderer #1, fitType = ${np.fitType}`);
        }
        if (np.viewSize.width !== this.viewSize.width || np.viewSize.height !== this.viewSize.height) {
            this.viewSize = Object.assign({}, np.viewSize);
            // console.log(`VIEW SIZE${callstackDepth()} WIDTH/HEIGHT:  ${this.viewSize.width}, ${this.viewSize.height}`);
            this.onViewResized(this.viewSize);
            console.log(`PenBasedRenderer #2, fitType = ${np.fitType}`);
        }
        // 2022/04/07 opacityConverter callback 변화의 따른 강제 rendering - june
        if (p.opacityConverter !== np.opacityConverter || p.replayStorage !== np.replayStorage) {
            opt.opacityConverter = np.opacityConverter;
            this.forceToReloadPage = true;
            ret = true;
            forceRenderStroke = true;
        }
        if (p.isPriorityView !== np.isPriorityView || p.isMainView !== np.isMainView) {
            opt.isPriorityView = np.isPriorityView || np.isMainView;
        }
        if ((p.pdf !== np.pdf) || (p.pdfPageNo !== np.pdfPageNo)) {
            if (p.pdf !== np.pdf)
                opt.pdf = np.pdf;
            if (p.pdfPageNo !== np.pdfPageNo)
                opt.pdfPageNo = np.pdfPageNo;
            rndr.changePdfPage(np.pdf, np.pdfPageNo, true);
            ret = true;
        }
        if (this.forceToReloadPage || (!isSamePage(np.pageInfo, p.pageInfo) && !isPlatePaper(np.pageInfo))) {
            this.changePagePrivate(np.pageInfo, np.pens, np.surfaceOwnerIds, np.writerIds, np.pdf, np.pdfPageNo, forceRenderStroke);
            this.forceToReloadPage = false;
        }
        // 2021/08/17
        if (p.mapperUpdatedCounter !== np.mapperUpdatedCounter) {
            this.changePagePrivate(np.pageInfo, np.pens, np.surfaceOwnerIds, np.writerIds, np.pdf, np.pdfPageNo);
            rndr.changePdfPage(np.pdf, np.pdfPageNo, false);
            ret = true;
        }
        // 같은 페이지의 다른 영역이 선택되었을 때에만 반응
        if (!isSamePageRect(s.cropRect, np.cropRect) && this._mounted) {
            this.setState({ cropRect: deepClone(np.cropRect) });
            const pageFlag = hasSamePage({ pageInfo: p.pageInfo, rect: null }, np.cropRect);
            // next pageInfo에 wild card(undefined)가 있거나, 같은 페이지라면
            if (hasNullPageInfo(np.cropRect) || pageFlag) {
                // 다른 영역이라면
                let flag = !hasSameRect(s.cropRect, np.cropRect);
                // // 또는 같은 영역이라도, 이전에 저장된 페이지와 다른 페이지라면
                flag = flag || (!hasSamePage(s.cropRect, np.cropRect));
                if (flag) {
                    this.renderer.zoomToRect(np.cropRect.rect);
                }
            }
        }
        if (p.forceDeltaTime !== np.forceDeltaTime) {
            this._replay.deltaTime = np.forceDeltaTime ? np.forceDeltaTime : 0;
        }
        if (this._replay.speed !== np.replaySpeed) {
            this._replay.speed = np.replaySpeed ? np.replaySpeed : 1;
        }
        if (this._replay.replayStorage !== np.replayStorage) {
            this.handleReplayStorageChanged(np.replayStorage);
        }
        if (p.playState !== np.playState) {
            switch (np.playState) {
                case PLAYSTATE.live: {
                    this.replayPause();
                    break;
                }
                case PLAYSTATE.play: {
                    this.replayStart();
                    break;
                }
                case PLAYSTATE.rewind: {
                    this.replayRewind();
                    break;
                }
                case PLAYSTATE.pause: {
                    this.replayPause();
                    break;
                }
                case PLAYSTATE.stop: {
                    this.replayPause();
                    break;
                }
            }
        }
        // 2021/08/04
        if (np.zoom !== p.zoom) {
            this.onScaleChanged(np.zoom);
            ret = true;
        }
        // 2021/04/05
        if (s.updateCounter !== ns.updateCounter)
            ret = true;
        // 2021/04/05
        if (p.onMouseDown !== np.onMouseDown)
            opt.onMouseDown = np.onMouseDown;
        if (p.onMouseMove !== np.onMouseMove)
            opt.onMouseMove = np.onMouseMove;
        if (p.onMouseUp !== np.onMouseUp)
            opt.onMouseUp = np.onMouseUp;
        if (p.onMouseWheel !== np.onMouseWheel)
            opt.onMouseWheel = np.onMouseWheel;
        if (p.onTouchTap !== np.onTouchTap)
            opt.onTouchTap = np.onTouchTap;
        if (p.onTouchPress !== np.onTouchPress)
            opt.onTouchPress = np.onTouchPress;
        // if (p.onCanvasPositionChanged !== np.onCanvasPositionChanged) opt.onCanvasPositionChanged = np.onCanvasPositionChanged;
        if (p.onViewPositionControlledBy !== np.onViewPositionControlledBy)
            opt.onViewPositionControlledBy = np.onViewPositionControlledBy;
        if (p.laserPointer !== np.laserPointer)
            opt.laserPointer = np.laserPointer;
        if (p.disableAutoFocus !== np.disableAutoFocus)
            opt.disableAutoFocus = np.disableAutoFocus;
        if (p.setViewFitFn !== np.setViewFitFn)
            opt.setViewFitFn = np.setViewFitFn;
        if (p.disableMousePen !== np.disableMousePen)
            opt.disableVirtualPen = np.disableMousePen;
        if (p.disablePanZoom !== np.disablePanZoom)
            opt.disablePanZoom = np.disablePanZoom;
        if (p.onCropRangeChagned !== np.onCropRangeChagned)
            opt.onCropRangeChagned = np.onCropRangeChagned;
        if (p.isCropMode !== np.isCropMode)
            rndr.setCropMode(np.isCropMode);
        if (p.showGrid !== np.showGrid)
            rndr.setDrawGridOn(np.showGrid);
        // if (p.pdf !== np.pdf) opt.pdf = np.pdf;
        // if (p.pdfPageNo !== np.pdfPageNo) opt.pdfPageNo = np.pdfPageNo;
        if (p.disableAnyMouseAction !== np.disableAnyMouseAction) {
            rndr.disableMouseAction(np.disableAnyMouseAction);
        }
        // 2021/08/15 점검, 제대로 잘 해 놨구만 (플레이트에 대한 것)
        if (p.enablePlateInput !== np.enablePlateInput) {
            opt.enablePlateInput = np.enablePlateInput;
            this.subscribedPens.forEach(pen => pen.setPageSizeRetreiveFn(rndr.getViewSize, np.enablePlateInput));
        }
        const hoverCursor = s.hoverCursor !== ns.hoverCursor;
        ret = ret || (p.replayStorage !== np.replayStorage) || hoverCursor;
        // ret = ret || (p.playState !== np.playState);
        // ret = ret || (p.deltaTime !== np.deltaTime
        // 2021/08/17
        ret = ret || (p.mapperUpdatedCounter !== np.mapperUpdatedCounter);
        return ret;
    }
    componentWillUnmount() {
        this._mounted = false;
        this.stopInterval();
        this.unsubscribeAllPensEvent();
        // 2021/07/06
        this.unsubscribeStaticInkStorageEvent();
        // if (this.props.fromStorage)
        this.unsubScriptStorageEvent();
        this.renderer.prepareUnmount();
        delete this._renderer;
        this._renderer = undefined;
        // this._inkstorage.removeEventListener(PageEventName.PAGE_CLEAR, this.removeAllCanvasObjectOnActivePage);
    }
    render() {
        var _a;
        return (_jsxs("div", Object.assign({ id: this._divId, style: {
                display: this.props.hidden ? "none" : "block",
                position: "absolute", top: 0, left: 0, right: 0, bottom: 0
            } }, { children: [!this.props.isOverlayView ?
                    _jsx("div", Object.assign({ id: `pdf-fabric_container`, style: Object.assign(Object.assign(Object.assign({}, pdfContainerDiv), this.canvasCssSize), { backgroundColor: "#FFF" }) }, { children: _jsx("img", { id: this.pdfCanvasId, alt: "", width: 0, height: 0, ref: (ref) => this.pdfCanvas = ref, style: Object.assign({}, pdfCanvas) }) }))
                    : "", !this.props.isPdfOnly ?
                    _jsxs(_Fragment, { children: [_jsx("div", Object.assign({ id: `completed_fabric_container`, style: Object.assign(Object.assign({}, inkContainerDivCompleted), this.canvasCssSize) }, { children: _jsx("canvas", { id: this.backCanvasId, 
                                    // width={this.viewSize.width}
                                    // height={this.viewSize.height}
                                    style: Object.assign({}, inkCanvasCompleted), ref: (ref) => this.backCanvas = ref }) })), _jsx("div", Object.assign({ id: `fabric_container`, style: Object.assign(Object.assign({}, inkContainerDiv), this.canvasCssSize) }, { children: _jsx("canvas", { id: this.canvasId, 
                                    // width={this.viewSize.width}
                                    // height={this.viewSize.height}
                                    style: Object.assign({}, inkCanvas), ref: (ref) => this.canvas = ref }) }))] })
                    : "", ((_a = this.state.hoverCursor) === null || _a === void 0 ? void 0 : _a.show) ?
                    _jsx(HoverCursor, { x: this.state.hoverCursor.x, y: this.state.hoverCursor.y, enable: this.state.hoverCursor.show, numTrackers: 10, numFollowings: this.state.hoverCursor.numFollowings, width: 20, color: this.state.hoverCursor.color, zIndex: 9009 })
                    :
                        ""] })));
    }
}
export function testOwnerAndWriter(stroke, owners, writers) {
    // 이건 참 헷갈리는 문제네.... filter를 filter 답게 쓰려면 아래와 같이
    const ownerValid = (!owners) || owners.includes(stroke.surfaceOwnerId);
    const writerValid = (!writers) || writers.includes(stroke.writerId);
    // 이전 버전과 호환성을 위해서는 아래와 같이
    // const ownerValid = (!owners) || (!stroke.surfaceOwnerId) || owners.includes(stroke.surfaceOwnerId);
    // const writerValid = (!writers) || (!stroke.writerId) || writers.includes(stroke.writerId);
    return ownerValid && writerValid;
}
//# sourceMappingURL=PenBasedRenderer.js.map